module.exports = __webpack_public_path__ + "media/logo_vit_prickar.4643f368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_vit_prickar.svg
// module id = 505
// module chunks = 0